import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  tiposColaborador: [],
};

const getters = {
  // Tipos Colaborador
  tiposColaborador: state => state.tiposColaborador.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  tiposColaboradorAtivo: state => state.tiposColaborador.filter(t => t.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Tipos Colaboradors
  async fetchTiposColaborador({ commit }) {
    const response = await axios.get(`${baseUrl}/tiposcolaboradores`);
    if (response.data) {
      commit('setTiposColaborador', response.data);
    } else {
      commit('setTiposColaborador', []);
    }
  },
  async fetchTiposColaboradorSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/tiposcolaboradores?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setTiposColaborador', response.data);
      } else {
        commit('setTiposColaborador', []);
      }
    } catch (error) {
      commit('setTiposColaborador', []);
    }
  },
  async addTipoColaborador({ commit }, tipoColaborador) {
    const response = await axios.post(`${baseUrl}/tiposcolaboradores`, tipoColaborador, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    tipoColaborador.IdTipoColaborador = response.data.IdTipoColaborador;
    commit('newTipoColaborador', tipoColaborador);
    return response.data.IdTipoColaborador;
  },
  async updateTipoColaborador({ commit }, updTipoColaborador) {
    await axios.put(`${baseUrl}/tiposcolaboradores`, updTipoColaborador, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateTipoColaborador', updTipoColaborador);
  },
  async deleteTipoColaborador({ commit }, id) {
    await axios.delete(`${baseUrl}/tiposcolaboradores/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeTipoColaborador', id);
  },
}

const mutations = {
  // Tipos Colaborador
  setTiposColaborador: (state, tiposColaborador) => state.tiposColaborador = tiposColaborador,
  newTipoColaborador: (state, tipoColaborador) => state.tiposColaborador.push(tipoColaborador),
  removeTipoColaborador: (state, id) => state.tiposColaborador = state.tiposColaborador.filter(tipoColaborador => tipoColaborador.IdTipoColaborador !== id),
  updateTipoColaborador: (state, updTipoColaborador) => {
    const index = state.tiposColaborador.findIndex(tipoColaborador => tipoColaborador.IdTipoColaborador === updTipoColaborador.IdTipoColaborador);
    if (index !== -1) {
      state.tiposColaborador.splice(index, 1, updTipoColaborador);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}